const state = {
    filters: {},
    sortBy: null,
};

const getters = {
    filters: (state) => state.filters,
    sortBy: (state) => state.sortBy,
    filterParams: ({filters, sortBy}) => ([
        ...(filters) ? ['filters='+JSON.stringify(filters)] : [],
        ...(sortBy) ? ['sort='+sortBy] : [],
    ])
};

const actions = {

};

const mutations = {
    addFilter: (state, filter) => state.filters = {...state.filters, ...filter},
    setFilters: (state, filters) => state.filters = filters,
    setSortBy: (state, {field, sortDesc}) => state.sortBy = ((sortDesc) ? '-' : '') + field,
};

export default {
    state,
    getters,
    actions,
    mutations,
}